import React from 'react';
import {
    Card,
    CardContent,
    CardDescription,
    CardHeader,
    CardTitle
} from '@components/ui/card';

interface FormSectionProps {
    title: string;
    description?: string;
    actions?: React.ReactNode;
    children: React.ReactNode;
}

export const FormSection = ({
    title,
    description,
    actions,
    children
}: FormSectionProps) => (
    <Card>
        <CardHeader className="flex flex-row items-start justify-between gap-4">
            <div>
                <CardTitle>{title}</CardTitle>
                {description && (
                    <CardDescription>{description}</CardDescription>
                )}
            </div>
            {actions}
        </CardHeader>
        <CardContent>{children}</CardContent>
    </Card>
);
